// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__30jgM","Button--secondary":"Button_Button--secondary__2OR7h","Button--primary":"Button_Button--primary__2CfB9"};